import i18n from "../../../constants/i18n";
import Et3Button from "../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { useEffect } from "react";

const KhattabatNewClients = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_NEW_CLIENTS",
      "KHATTABAT_NEW_CLIENTS"
    );
  }, []);
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{ position: "relative" }}
    >
      <Et3PageTitle
        title={i18n.get("NEW_CLIENTS")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Et3Button
        text={"ASSIGN_CLIENT_TO_ME"}
        isEnabled={true}
        size={"LARGE"}
        onClick={() => {
          getCorePopUpStore().openConfirmationPopUps(
            "KHATTABAT_CLIENT_ASSIGN_CONFIRMATION_POPUP"
          );
        }}
        type={"GET"}
      />
    </ET3PageDiv>
  );
});

export default KhattabatNewClients;
